import React, { useEffect, useState } from "react";
import {
  Avatar,
  Button,
  Card,
  CardContent,
  Typography,
  Box,
  LinearProgress,
} from "@mui/material";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import UserAvatar from "components/UserAvatar/UserAvatar";
import ErrorToast from "components/Toaster/ErrorToast";
import AdhocScheduleMeetingModal from './AdhocScheduleMeetingModal';
import { findMenteeCourse } from "./findMenteeCourse";

const WorkspaceSidebarNew = () => {
  const userProfile = useSelector((state) => state.userProfile.data);
  const userRole = userProfile?.role;
  const isMentor = userRole === "mentor";
  const [courseData, setCourseData] = useState(null);

  const [openAdhocMeeting, setOpenAdhocMeeting] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  // For mentors: show mentee info
  // For mentees: show mentor info
  const getDisplayInfo = () => {
    if (!courseData) {
      return { name: "N/A", location: "—", avatar: null };
    }

    if (isMentor) {
      // Mentor sees mentee info
      const name = [courseData.first_name, courseData.last_name]
        .filter(Boolean)
        .join(" ")
        .trim() || courseData.email || "N/A";
      const location = [courseData.state, courseData.country]
        .filter((x) => x != null && String(x).trim() !== "")
        .join(", ") || "—";
      return { name, location, avatar: courseData.avatar };
    } else {
      // Mentee sees mentor info
      const name = courseData.mentor_name || "N/A";
      const email = courseData.mentor_email || "";
      return { name, location: email, avatar: null };
    }
  };

  const displayInfo = getDisplayInfo();

  const formatDate = (timestamp) => {
    if (!timestamp) return "N/A";
    const date = new Date(timestamp);
    if (isNaN(date)) return "Invalid Date";
    return date?.toISOString()?.split("T")[0];
  };

  const handleViewButtonClick = () => {
    navigate("/profile");
  };

  useEffect(() => {
    const matchedCourse = findMenteeCourse(id);
    if (matchedCourse) {
      setCourseData(matchedCourse);
    }
  }, [id]);

  return (
    <Box>
      <Box display={"flex"} flexDirection={"row"}>
        <Typography sx={{ color: "#6b7280", fontSize: "12px", fontFamily: 'Be Vietnam Pro' }}>
          Started
        </Typography>
        <Typography sx={{ color: "#6b7280", fontSize: "12px", ml: 1, fontFamily: 'Be Vietnam Pro' }}>
          {formatDate(courseData?.timestamp)}
        </Typography>
      </Box>
      <Typography
        sx={{ color: "#202124", fontSize: "24px", fontWeight: 500, mb: 1, fontFamily: 'Be Vietnam Pro' }}
      >
        {courseData?.name}
      </Typography>
      <Typography sx={{ color: "#6b7280", fontSize: "12px", fontFamily: 'Be Vietnam Pro' }}>
        {courseData?.description}
      </Typography>
      <Box display={"flex"} mt={4} justifyContent={"space-between"}>
        <Typography
          sx={{
            fontSize: "10px",
            color: "#868686",
            fontFamily: 'Be Vietnam Pro'
          }}
        >
          {courseData?.progress}% completed
        </Typography>
        <Typography
          sx={{
            fontSize: "10px",
            color: "#868686",
            fontFamily: 'Be Vietnam Pro'
          }}
        >
          {`${courseData?.is_completed ? "Completed" : "In Progress"}`}
        </Typography>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <LinearProgress
          variant="determinate"
          value={courseData?.progress || 0}
          sx={{
            flex: 1,
            borderRadius: "5px",
            width: "100%",
            height: "8px",
            mt: 1,
          }}
        />
      </Box>
      <Card sx={{ mt: 4 }}>
        <CardContent sx={{ padding: 2 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
            <Box display={"flex"}>
              <UserAvatar
                avatar={displayInfo.avatar}
                fullName={displayInfo.name}
              />
              <Box display={"flex"} flexDirection={"column"} ml={1}>
                <Typography sx={{ color: "#0172A6", fontSize: "16px", fontFamily: 'Be Vietnam Pro' }}>
                  {displayInfo.name}
                </Typography>
                <Typography sx={{ color: "#6b7280", fontSize: "12px", fontFamily: 'Be Vietnam Pro' }}>
                  {displayInfo.location}
                </Typography>
              </Box>
            </Box>
            <Box display={"flex"} justifyContent={"end"} gap={1}>
              <VideocamOutlinedIcon
                sx={{ color: "#6b7280", width: "24px", height: "24px" }}
              />
              <FolderOpenOutlinedIcon
                sx={{ color: "#6b7280", width: "24px", height: "24px" }}
              />
            </Box>
          </Box>
          {isMentor && (
            <Button
              variant="outlined"
              color="primary"
              onClick={() => setOpenAdhocMeeting(true)}
              fullWidth
              sx={{
                textTransform: 'none',
                fontFamily: 'Be Vietnam Pro',
                fontSize: '14px',
                height: '36px',
                mt: 1
              }}
            >
              Schedule Adhoc Call
            </Button>
          )}
        </CardContent>
      </Card>
      {isMentor && (
        <AdhocScheduleMeetingModal
          open={openAdhocMeeting}
          onClose={() => setOpenAdhocMeeting(false)}
          courseId={id}
        />
      )}
    </Box>
  );
};

export default WorkspaceSidebarNew;
